<template>
    <div>
        <div class="form-row mb-1">
            <div class="col-md-12 form-group">
                <label>
                    <strong>{{question.content}}</strong>
                    <small class="text-red" v-if="question.is_required">{{$lang('(wymagane)')}}</small>
                    <template v-if="correctAnswers !== null && correctAnswers[question.id] !== undefined">
                        <template v-if="correctAnswers[question.id] === true">
                            <i class="fa fa-check text-success ml-2" aria-hidden="true"></i>
                            <span class="text-success">{{$lang('Poprawna odpowiedź')}}</span>
                        </template>
                        <template v-else>
                            <i class="fa fa-times text-danger ml-2" aria-hidden="true"></i>
                            <span class="text-danger">{{$lang('Błędna odpowiedź')}}</span>
                        </template>
                    </template>
                </label>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <div class="bg-icon"><i class="fa fa-user" aria-hidden="true"></i></div>
                    </div>
                    <select class="form-control"
                            :name="'questions['+question.id+']'"
                            :id="'questions['+question.id+']'"
                            v-model="answer"
                            :disabled="disabled">
                        <option v-if="question.default_answer === null" value="">{{$lang('Brak')}}</option>
                        <option v-for="person in question.people" :value="person.id">
                            {{person.surname + ' ' + person.name}}
                        </option>
                    </select>
                </div>

                <div v-if="correctAnswersPreview && correctAnswersPreview[question.id] !== undefined">
                    <span>{{$lang('Poprawna odpowiedź: ')}}</span>
                    <span class="text-success">{{correctAnswersPreview[question.id]}}</span>
                </div>

                <div v-if="errors['questions.'+question.id]" class="invalid-feedback d-block">
                    {{ errors['questions.'+question.id][0] }}
                </div>
            </div>
        </div>
        <template v-for="nestedQuestion in question.nestedQuestions">
            <component :is="'survey-'+nestedQuestion.questionTypeElementName"
                       v-if="answer.toString() === nestedQuestion.triggering_answer[0]"
                       v-bind="{question: nestedQuestion,
                           surveyAnswers: surveyAnswers,
                           correctAnswers: correctAnswers,
                           correctAnswersPreview: correctAnswersPreview,
                           disabled: disabled,
                           errors: errors,
                           old: old}">
            </component>
        </template>
    </div>
</template>

<script>
export default {
    name: "survey-select-people",
    props: {
        question: {type: Object|Array, required: true},
        surveyAnswers: {type: Object|Array|null, required: true},
        correctAnswers: {type: Object|Array|null, required: true},
        correctAnswersPreview: {type: Object|Array|null, required: true},
        disabled: {type: Boolean, required: true},
        old: {type: Array|Object|null, required: true},
        errors: {type: Array|Object, required: true}
    },
    data() {
        return {
            answer: '',
        }
    },
    methods: {
        setAnswer() {
            if (this.old) {
                if (this.old[this.question.id]) {
                    this.answer = this.old[this.question.id] ?? '';
                }
            }
            else if (this.surveyAnswers && this.surveyAnswers[this.question.id]) {
                this.surveyAnswers[this.question.id].forEach(surveyAnswer => {
                    this.answer = surveyAnswer.content ?? '';
                });
            }
            else if (this.question.default_answer){
                this.answer = this.question.default_answer;
            }
        },
    },
    mounted() {
        this.setAnswer();
    },
}
</script>
